import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import axiosInstance from '../../utilities/configureAxios';

// Logs store update when action is dispatch

const configureMiddlewares = () => {
  const middlewares = [
    thunk.withExtraArgument({
      api: axiosInstance,
    }),
  ];

  if (process.env.NODE_ENV === 'development') {
    const logger = createLogger();
    middlewares.push(logger);
  }
  return middlewares;
};

export default configureMiddlewares();
